<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12"> Non autorizzato 2 </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Notfound2',
}
</script>
